import Downloader from 'js-file-downloader'
export const ApiInvoicingDocuments = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const find = async (id) => {
    const result = await axios.get(`/api/invoicing-documents/${id}`)
    return result.data
  }

  const trash = async (id) => {
    const result = await axios.delete(`/api/invoicing-documents/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/invoicing-documents')
    return result.data
  }

  const recreate = async (id) => {
    const result = await axios.get(`/api/invoicing-documents/recreate/${id}`)
    return result.data
  }

  const open = async (id) => {
    const { data } = await axios.get(`/api/invoicing-documents/open/${id}`)
    const { buffer } = data
    return buffer
  }

  const save = async (id, payload) => {
    const result = await axios.post(`/api/invoicing-documents/${id}`, payload)
    return result.data
  }

  const download = async (filename, id) => {
    const token = sessionStorage.getItem('token')
    const headers = []
    headers.push(
      {
        name: 'Authorization',
        value: 'Bearer ' + token
      }
    )

    const params = {
      method: 'get',
      autoStart: false,
      headers,
      filename,
      url: `${obuBaseUrl}api/invoicing-documents/download/${id}`
    }

    console.log(params)

    const download = new Downloader(params)
    return download
  }

  return {
    invoicingDocumentsDownload: download,
    invoicingDocumentsDelete: trash,
    invoicingDocumentsFind: find,
    invoicingDocumentsLoad: load,
    invoicingDocumentsOpen: open,
    invoicingDocumentsRecreate: recreate,
    invoicingDocumentsSave: save
  }
}
